/* EHI — Earth Harmony Initiatives · Redesign 2026 · interactions */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  root.classList.add('ehi-js');
  if (doc.body) doc.body.classList.add('ehi-site');

  var header = null, progress = null, lastY = window.scrollY, ticking = false;
  var heroes = [], parallaxEls = [], rootsSvgs = [];

  /* ---------- Reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }) : null;

  function split(el) {
    if (el.getAttribute('data-split-done')) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    var words = text.split(' ');
    el.textContent = '';
    if (!el.getAttribute('aria-hidden')) el.setAttribute('aria-label', text);
    words.forEach(function (w, i) {
      var outer = doc.createElement('span');
      outer.className = 'w';
      outer.setAttribute('aria-hidden', 'true');
      var inner = doc.createElement('span');
      inner.textContent = w;
      inner.style.setProperty('--i', i);
      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(doc.createTextNode(' '));
    });
    el.classList.add('ehi-split');
    el.setAttribute('data-split-done', '1');
  }

  function observe(scope) {
    scope.querySelectorAll('[data-split]').forEach(split);
    scope.querySelectorAll('.ehi-reveal, [data-split]').forEach(function (el) {
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Scroll-driven updates (one rAF loop) ---------- */
  function clamp(v, a, b) { return Math.min(Math.max(v, a), b); }
  function update() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight, max = root.scrollHeight - vh;
    if (progress) progress.style.setProperty('--p', max > 0 ? (y / max).toFixed(4) : 0);
    if (header && !header.classList.contains('is-menu-open')) {
      header.classList.toggle('is-solid', y > 40);
      if (y > lastY + 4 && y > 320) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y <= 320) header.classList.remove('is-hidden');
    }
    lastY = y;
    if (reduce) return;
    heroes.forEach(function (h) {
      var r = h.getBoundingClientRect();
      h.style.setProperty('--hp', clamp(-r.top / r.height, 0, 1).toFixed(4));
    });
    parallaxEls.forEach(function (el) {
      var host = el.parentElement, r = host.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      var amt = parseFloat(el.getAttribute('data-parallax')) || 60;
      el.style.setProperty('--py', (c * -amt).toFixed(1) + 'px');
    });
    rootsSvgs.forEach(function (svg) {
      var r = svg.getBoundingClientRect();
      var p = clamp((vh * 0.9 - r.top) / (r.height * 0.85), 0, 1);
      svg.__paths.forEach(function (pa) { pa.style.strokeDashoffset = (pa.__len * (1 - p)).toFixed(1); });
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function setHeaderHeight() {
    if (header) root.style.setProperty('--ehi-header-h', header.offsetHeight + 'px');
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var btn = doc.querySelector('[data-ehi-burger]'), menu = doc.getElementById('ehi-menu');
    if (!btn || !menu || btn.__ehi) return;
    btn.__ehi = 1;
    function set(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      doc.body.classList.toggle('ehi-lock', open);
      if (header) { header.classList.toggle('is-menu-open', open); header.classList.remove('is-hidden'); }
      if (open) {
        var first = menu.querySelector('a');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
    }
    btn.addEventListener('click', function () { set(!menu.classList.contains('is-open')); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) { set(false); btn.focus(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 989 && menu.classList.contains('is-open')) set(false);
    });
  }

  /* ---------- Hero video ---------- */
  function initHero(h) {
    heroes.push(h);
    var v = h.querySelector('video'), t = h.querySelector('[data-hero-toggle]');
    if (!v) return;
    var show = function () { h.classList.add('is-playing'); };
    v.addEventListener('playing', show);
    if (reduce) {
      v.removeAttribute('autoplay'); v.pause(); h.classList.add('is-paused');
      if (t) t.setAttribute('aria-label', 'Play video');
    } else {
      var p = v.play(); if (p && p.catch) p.catch(function () { h.classList.add('is-paused'); });
      if (!v.paused) show();
    }
    if (t) t.addEventListener('click', function () {
      if (v.paused) { v.play(); h.classList.remove('is-paused'); t.setAttribute('aria-label', 'Pause video'); }
      else { v.pause(); h.classList.add('is-paused'); t.setAttribute('aria-label', 'Play video'); }
    });
  }

  /* ---------- Roots drawing ---------- */
  function initRoots(svg) {
    var paths = [].slice.call(svg.querySelectorAll('path'));
    paths.forEach(function (p) {
      var l = 0; try { l = p.getTotalLength(); } catch (e) { l = 1000; }
      p.__len = l; p.style.strokeDasharray = l; p.style.strokeDashoffset = reduce ? 0 : l;
    });
    svg.__paths = paths;
    if (!reduce) rootsSvgs.push(svg);
  }

  /* ---------- Principles (Mission) ---------- */
  function initPrinciples(s) {
    var items = [].slice.call(s.querySelectorAll('.ehi-principle'));
    var imgs = [].slice.call(s.querySelectorAll('.ehi-principles__img'));
    var list = s.querySelector('.ehi-principles__list');
    var count = s.querySelector('[data-principle-count]');
    function act(i) {
      if (i < 0) return;
      items.forEach(function (it, j) { it.classList.toggle('is-active', i === j); });
      imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
      if (list) list.classList.add('has-active');
      if (count) count.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    }
    items.forEach(function (it, i) {
      it.addEventListener('mouseenter', function () { act(i); });
      it.addEventListener('focusin', function () { act(i); });
    });
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) act(items.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { o.observe(it); });
    }
    act(0);
    var svg = s.querySelector('[data-roots]');
    if (svg) initRoots(svg);
  }

  /* ---------- Approach orbit ---------- */
  function initApproach(s) {
    var nodes = [].slice.call(s.querySelectorAll('[data-node]'));
    var items = [].slice.call(s.querySelectorAll('[data-item]'));
    var svg = s.querySelector('[data-orbit-lines]');
    var n = nodes.length; if (!n) return;
    var R = 40, DUR = 6500, cur = 0, timer = null, auto = true, inView = false;
    s.style.setProperty('--dur', DUR + 'ms');
    nodes.forEach(function (nd, i) {
      var a = (-90 + i * 360 / n) * Math.PI / 180;
      var x = 50 + R * Math.cos(a), y = 50 + R * Math.sin(a);
      nd.style.left = x.toFixed(3) + '%'; nd.style.top = y.toFixed(3) + '%';
      if (svg) {
        var ln = doc.createElementNS('http://www.w3.org/2000/svg', 'line');
        ln.setAttribute('x1', 50); ln.setAttribute('y1', 50);
        ln.setAttribute('x2', x.toFixed(3)); ln.setAttribute('y2', y.toFixed(3));
        ln.setAttribute('class', 'ehi-orbit__line');
        svg.insertBefore(ln, svg.firstChild);
        nd.__line = ln;
      }
    });
    function restart() {
      clearTimeout(timer);
      s.classList.remove('is-auto');
      void s.offsetWidth;
      if (auto && !reduce && inView) {
        s.classList.add('is-auto');
        timer = setTimeout(function () { act(cur + 1); }, DUR);
      }
    }
    function act(i) {
      cur = (i + n) % n;
      nodes.forEach(function (nd, j) {
        var on = j === cur;
        nd.classList.toggle('is-active', on);
        nd.setAttribute('aria-selected', on ? 'true' : 'false');
        nd.setAttribute('tabindex', on ? '0' : '-1');
        if (nd.__line) nd.__line.classList.toggle('is-active', on);
      });
      items.forEach(function (it, j) {
        it.classList.toggle('is-active', j === cur);
        it.setAttribute('aria-hidden', j === cur ? 'false' : 'true');
      });
      restart();
    }
    function manual(i) { auto = false; act(i); }
    nodes.forEach(function (nd, i) {
      nd.addEventListener('click', function () { manual(i); });
      if (canHover) nd.addEventListener('mouseenter', function () { manual(i); });
      nd.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); manual(cur + 1); nodes[cur].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); manual(cur - 1); nodes[cur].focus(); }
      });
    });
    var prev = s.querySelector('[data-prev]'), next = s.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { manual(cur - 1); });
    if (next) next.addEventListener('click', function () { manual(cur + 1); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; restart(); }, { threshold: 0.3 }).observe(s);
    }
    act(0);
  }

  /* ---------- Team bios ---------- */
  function initTeam(s) {
    s.querySelectorAll('[data-dialog-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = doc.getElementById(b.getAttribute('data-dialog-open'));
        if (d && typeof d.showModal === 'function') { d.showModal(); doc.body.classList.add('ehi-lock'); }
        else if (d) { d.setAttribute('open', ''); }
      });
    });
    s.querySelectorAll('dialog').forEach(function (d) {
      d.addEventListener('close', function () { doc.body.classList.remove('ehi-lock'); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      var c = d.querySelector('[data-dialog-close]');
      if (c) c.addEventListener('click', function () { if (d.close) d.close(); else d.removeAttribute('open'); });
    });
  }

  /* ---------- Stories hover cursor ---------- */
  function initStories(s) {
    if (!canHover) return;
    s.querySelectorAll('.ehi-story__media').forEach(function (m) {
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect();
        m.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        m.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic(scope) {
    if (reduce || !canHover) return;
    scope.querySelectorAll('[data-magnetic]').forEach(function (b) {
      if (b.__mag) return; b.__mag = 1;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.22, y = (e.clientY - r.top - r.height / 2) * 0.32;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  function once(fn) { return function (el) { if (el.__ehiInit) return; el.__ehiInit = 1; fn(el); }; }

  function initScope(scope) {
    observe(scope);
    scope.querySelectorAll('[data-ehi-hero]').forEach(once(initHero));
    scope.querySelectorAll('[data-ehi-principles]').forEach(once(initPrinciples));
    scope.querySelectorAll('[data-ehi-approach]').forEach(once(initApproach));
    scope.querySelectorAll('[data-ehi-team]').forEach(once(initTeam));
    scope.querySelectorAll('[data-ehi-stories]').forEach(once(initStories));
    scope.querySelectorAll('[data-parallax]').forEach(function (el) { if (parallaxEls.indexOf(el) < 0) parallaxEls.push(el); });
    scope.querySelectorAll('[data-ehi-top]').forEach(once(function (b) {
      b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    }));
    initMagnetic(scope);
  }

  function boot() {
    if (doc.body) doc.body.classList.add('ehi-site');
    header = doc.querySelector('[data-ehi-header]');
    progress = doc.querySelector('.ehi-progress');
    if (!doc.querySelector('.ehi-grain')) {
      var g = doc.createElement('div'); g.className = 'ehi-grain'; g.setAttribute('aria-hidden', 'true'); doc.body.appendChild(g);
    }
    initMenu();
    initScope(doc);
    setHeaderHeight();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setHeaderHeight(); onScroll(); });
    window.addEventListener('load', function () { setHeaderHeight(); update(); });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor support */
  doc.addEventListener('shopify:section:load', function (e) {
    header = doc.querySelector('[data-ehi-header]');
    initMenu();
    initScope(e.target);
    setHeaderHeight();
    update();
  });
})();
